import { BaseApiModule, AuthApiModule, LandlordApiModule, AvailabilityApiModule } from './modules'

export class WebApi {
  public readonly base: BaseApiModule
  public readonly auth: AuthApiModule
  public readonly landlord: LandlordApiModule
  public readonly availability: AvailabilityApiModule

  constructor(url = '') {
    this.base = new BaseApiModule(url)
    this.auth = new AuthApiModule(url)
    this.landlord = new LandlordApiModule(url)
    this.availability = new AvailabilityApiModule(url)
  }
}

const webApiInstance = new WebApi()

export default webApiInstance
